import { calcularFechaFinContrato, normalizarFechaContrato } from './contratoSolapamiento';

/** Día siguiente a YYYY-MM-DD (inicio de la renovación). */
export function fechaInicioRenovacion(fechaFin) {
  const fin = normalizarFechaContrato(fechaFin);
  if (!fin) return null;

  const [y, m, d] = fin.split('-').map(Number);
  const date = new Date(Date.UTC(y, m - 1, d));
  date.setUTCDate(date.getUTCDate() + 1);

  const yy = date.getUTCFullYear();
  const mm = String(date.getUTCMonth() + 1).padStart(2, '0');
  const dd = String(date.getUTCDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/** Hoy en YYYY-MM-DD (UTC local calendar via local date parts). */
export function fechaHoyLocal() {
  const n = new Date();
  const yy = n.getFullYear();
  const mm = String(n.getMonth() + 1).padStart(2, '0');
  const dd = String(n.getDate()).padStart(2, '0');
  return `${yy}-${mm}-${dd}`;
}

/**
 * ¿El contrato ya venció? (fecha_fin < hoy).
 * Sin fecha_fin = no vencido.
 */
export function contratoEstaVencido(contrato, hoy = fechaHoyLocal()) {
  const fin =
    normalizarFechaContrato(contrato?.fecha_fin) ||
    calcularFechaFinContrato(contrato?.fecha_inicio, contrato?.plazo_meses, contrato?.plazo_dias);
  if (!fin) return false;
  return fin < hoy;
}
